module.exports = {"tabletHeightBuffer":"190px"};